import { escapeHtml, downloadBlob } from './helpers';

export function exportToPDF(printAreaEl, data) {
  if (!printAreaEl) return;
  const resumeHTML = printAreaEl.innerHTML;

  const fullDoc = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${escapeHtml(data.name || 'Resume')}</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap">
<style>
  @page { size: letter; margin: 0; }
  html, body {
    margin: 0; padding: 0; background: white;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .resume-page {
    box-shadow: none !important;
    margin: 0 !important;
  }
  @media print {
    body { background: white; }
  }
</style>
</head>
<body>
${resumeHTML}
<script>
  (function() {
    function go() {
      try { window.focus(); window.print(); } catch (e) { console.error(e); }
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() { setTimeout(go, 100); });
    } else {
      setTimeout(go, 600);
    }
  })();
</script>
</body>
</html>`;

  const w = window.open('', '_blank', 'width=900,height=1100');
  if (!w) {
    const blob = new Blob([fullDoc], { type: 'text/html;charset=utf-8' });
    downloadBlob(blob, ((data.name || 'resume').replace(/[^a-z0-9]+/gi, '_').toLowerCase()) + '.html');
    alert("Pop-ups are blocked, so we downloaded an HTML file instead — open it in your browser and use Ctrl/Cmd+P to save as PDF.");
    return;
  }
  w.document.open();
  w.document.write(fullDoc);
  w.document.close();
}
